module.exports = __webpack_public_path__ + "img/器械备案-加水印.90f04c34.png";